// extracted by mini-css-extract-plugin
module.exports = {"About":"About_About__3q04_"};